import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { LoopConfig } from './LoopConfig';
import { LoopNode, loopVisualDefinition } from './LoopNode';
import {
  LoopConfigType,
  defaultLoopConfig,
  validateLoopConfig,
  getLoopPreviewText,
} from './schema';

export { LoopNode } from './LoopNode';
export { LoopConfig } from './LoopConfig';
export type { LoopConfigType } from './schema';

/** Full definition for the registry */
export const loopDefinition: NodeDefinition<LoopConfigType> = {
  ...loopVisualDefinition,
  category: 'flow',
  paletteGroup: 'Flow Control',
  NodeComponent: LoopNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: LoopConfig,
  defaultConfig: () => ({ ...defaultLoopConfig }),
  validateConfig: validateLoopConfig,
  getPreviewText: getLoopPreviewText,
};
